export enum AddressVariants {
  Location = 'Location',
  Email = 'Email',
}

export interface AddressBase {
  title: string;
  address: string;
  addressTop?: string;
}

export interface AddressLocation extends AddressBase {
  cityZip: string;
  variant: AddressVariants.Location;
}

export interface AddressEmail extends AddressBase {
  link: string;
  variant: AddressVariants.Email;
}

export type AddressType = AddressLocation | AddressEmail;
